import { render, staticRenderFns } from "./EditInstance.vue?vue&type=template&id=1010c558"
import script from "./EditInstance.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditInstance.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports